"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.validateSku = validateSku;
exports.validateStore = validateStore;
var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _constants = require("../../constants/constants");
var _utils = require("../../utils/utils");
function validateStore(_x) {
  return _validateStore.apply(this, arguments);
}
function _validateStore() {
  _validateStore = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee(storeId) {
    var experimentIds,
      utmExperience,
      url,
      sessionId,
      headers,
      response,
      data,
      _args = arguments;
    return _regenerator["default"].wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          experimentIds = _args.length > 1 && _args[1] !== undefined ? _args[1] : [];
          utmExperience = _args.length > 2 && _args[2] !== undefined ? _args[2] : null;
          _context.prev = 2;
          url = new URL(_constants.API_ENDPOINTS.validateStore(storeId));
          experimentIds.forEach(function (id) {
            return url.searchParams.append('experimentIds', id);
          });
          // Lets the backend honour an experience override (bwa / bwa_none / bwa_checkout_none)
          // instead of resolving the bwa-experience mutant, so the treatment it reports back
          // matches the experience the shopper actually gets. Unknown values are ignored.
          if (utmExperience) {
            url.searchParams.append('utmExperience', utmExperience);
          }
          sessionId = (0, _utils.getBwaMutantSessionId)();
          headers = sessionId ? (0, _defineProperty2["default"])({}, _constants.BWA_SESSION_HEADER, sessionId) : {};
          _context.next = 10;
          return fetch(url.toString(), {
            headers: headers
          });
        case 10:
          response = _context.sent;
          _context.next = 13;
          return response.json();
        case 13:
          data = _context.sent;
          if (data.bwaSessionId) {
            (0, _utils.setBwaMutantSessionId)(data.bwaSessionId);
          }
          if (data.ecpSessionId) {
            (0, _utils.setEcpSessionId)(data.ecpSessionId);
          }
          return _context.abrupt("return", data);
        case 19:
          _context.prev = 19;
          _context.t0 = _context["catch"](2);
          console.error("Error validating Store:", _context.t0);
        case 22:
        case "end":
          return _context.stop();
      }
    }, _callee, null, [[2, 19]]);
  }));
  return _validateStore.apply(this, arguments);
}
function validateSku(_x2, _x3) {
  return _validateSku.apply(this, arguments);
}
function _validateSku() {
  _validateSku = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee2(storeId, variantId) {
    var sessionId, headers, response;
    return _regenerator["default"].wrap(function _callee2$(_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          sessionId = (0, _utils.getBwaMutantSessionId)();
          headers = sessionId ? (0, _defineProperty2["default"])({}, _constants.BWA_SESSION_HEADER, sessionId) : {};
          _context2.prev = 2;
          _context2.next = 5;
          return fetch(_constants.API_ENDPOINTS.validateSku(storeId, variantId), {
            headers: headers
          });
        case 5:
          response = _context2.sent;
          _context2.next = 8;
          return response.json();
        case 8:
          return _context2.abrupt("return", _context2.sent);
        case 11:
          _context2.prev = 11;
          _context2.t0 = _context2["catch"](2);
          console.error("Error validating Sku:", _context2.t0);
        case 14:
        case "end":
          return _context2.stop();
      }
    }, _callee2, null, [[2, 11]]);
  }));
  return _validateSku.apply(this, arguments);
}
//# sourceMappingURL=validate.js.map
